import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
export const Event = ({ item, index }) => {
  // console.log("dashboard//events//item",item?.item);
  console.log("dashboard//events//index//item", item);
  // console.log("dashboard//item//webinarPlatform",index?.webinarPlatform,item);

  // const date = new Date(item?.startDate);
  // const day = String(date.getDate()).padStart(2, "0");
  // const month = String(date.getMonth() + 1).padStart(2, "0");
  // const year = date.getFullYear();
  // const formattedDate = `${day}/${month}/${year}`;
  const options = {
    timeZone: "Asia/Kolkata",
    hour12: true,
    hour: "2-digit",
    minute: "2-digit",
  };
  const formattedTime = new Date(item?.startDate).toLocaleString(
    "en-IN",
    options
  );

  const navigate = useNavigate();

  console.log(formattedTime);

  return (
    <>
      <div
        style={{ backgroundColor: index % 2 === 0 ? "#f7f7f7" : "#fffff" }}
        className="event-div"
      >
        <div className="event-details">
          <div className="time-number">
            <p>{item?.webinarPlatform ? formattedTime : formattedTime}</p>
          </div>
          <p style={{ fontWeight: "600" }}>
            {item?.webinarPlatform ? "Webinar" : "Batch Commencement"}
          </p>
          <span style={{ fontSize: ".8rem", color: "#808080" }}>
            {item?.webinarPlatform ? `(${item?.title})` : `(${item?.batchId})`}
          </span>
        </div>
        <Typography
          style={{ fontSize: ".8rem", color: "blue", cursor: "pointer" }}
          onClick={() => {
            console.log("item", item)
            item?.webinarPlatform
              ? navigate(`/webinar/view/${item?.id}/1`)
              : navigate(`/batch/batchesoverview/${item?.course?.id}/${item?.course?.courseName}`);
          }}
        >
          more details
        </Typography>
      </div>
    </>
  );
};
